module.exports = __webpack_public_path__ + "media/day/248-263a02ec.svg";